import { useEffect, useState } from 'react';
import { getAllUsers } from '../../services/admin';
import { UserProfile } from '../../context/AuthContext';
import styles from './Admin.module.css';

export function AdminOverview() {
  const [users, setUsers] = useState<UserProfile[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const data = await getAllUsers();
      setUsers(data);
      setLoading(false);
    };
    fetchStats();
  }, []);

  if (loading) return <div>Loading analytics...</div>;

  const totalUsers = users.length;
  const deletedUsers = users.filter(u => u.status === 'deleted').length;
  const admins = users.filter(u => u.role === 'admin' || u.role === 'super_admin').length;

  return (
    <div>
      <header className={styles.pageHeader}>
        <h1>System Overview</h1>
      </header>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Total Users</h3>
          <div className={styles.value}>{totalUsers}</div>
        </div>
        <div className={styles.statCard}>
          <h3>Active Admins</h3>
          <div className={styles.value}>{admins}</div>
        </div>
        <div className={styles.statCard}>
          <h3>Deleted Accounts</h3>
          <div className={styles.value}>{deletedUsers}</div>
        </div>
        <div className={styles.statCard}>
          <h3>Total Revenue</h3>
          <div className={styles.value}>$0.00</div>
        </div>
        <div className={styles.statCard}>
          <h3>Refund Requests</h3>
          <div className={styles.value}>0</div>
        </div>
        <div className={styles.statCard}>
          <h3>Reports Generated</h3>
          <div className={styles.value}>--</div>
        </div>
      </div>
    </div>
  );
}
